import { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import { InteractionStatus } from "@azure/msal-browser";

const Logout = () => {
  const history = useNavigate();
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      if (isAuthenticated) {
        instance.logoutRedirect().then(() => {
          history('/');
        });
      } else {
        history('/');
      }
    }
  }, [instance, inProgress, isAuthenticated]);

  return null;
};

export default withRouter(Logout);
